<template>
  <main>
    <div data-scroll-el="pdpContainer" />
    <div class="container" :class="{ 'fit-finder-container': $feature.showFitFinderOnPDP }">
      <slot name="notifications" />
      <transition name="fade">
        <div v-if="productPending && !product">
          <slot name="skeletons" />
        </div>
        <div v-else-if="product">
          <slot name="breadcrumbs" />
          <div :class="brandClasses.grid">
            <!-- Product Heading Section -->
            <section :class="[brandClasses.heading, { 'md:hidden': stickyDetailsColumn }]">
              <slot name="heading" />
              <slot name="klarna-payments" />
              <slot name="paypal-payments" />
            </section>
            <section
              :class="[
                brandClasses.gallery,
                { 'md:sticky': $feature.showFullscreenGridOnPDP },
              ]"
              :style="{ top: pxToRem(header.height.navigation) }"
            >
              <slot name="gallery" />
            </section>
            <section
              :class="[brandClasses.details, {
                'md:sticky !md:row-start-1': stickyDetailsColumn,
                [brandClasses.detailsSticky]: stickyDetailsColumn,
              }]"
              :style="{ top: pxToRem(header.height.navigation) }"
            >
              <slot name="details-heading" />
              <slot name="reviews-summary" />
              <slot name="variant-selection" />
              <slot name="size-and-fit" />
              <slot name="upsells" />
              <slot name="espot-above-add-to-cart" />
              <slot name="ctas" />
              <slot name="shipping-methods" />
              <slot name="espot-above-accordions" />
              <slot name="shop-the-look" />
              <slot name="accordions" />
              <slot name="espot-below-accordions" />
            </section>
          </div>
          <div :class="brandClasses.grid">
            <section :class="[brandClasses.eSpotsAndReviews, $feature.showFullscreenGridOnPDP ? brandClasses.gridFullWidth : brandClasses.gridPartialWidth]">
              <slot name="espot-lazy-below-gallery" />
              <slot name="reviews" />
            </section>
          </div>
        </div>
      </transition>
      <slot name="recommendations" />
    </div>
    <div v-if="$feature.enablePDPESpots && eSpots?.['lazy-above-footer']" class="container md:b-t md:b-grey-70">
      <slot name="espot-lazy-above-footer" />
    </div>
    <client-only>
      <teleport to="body">
        <slot name="body" />
      </teleport>
    </client-only>
    <slot />
  </main>
</template>

<script setup lang="ts">
defineSlots<{
  'accordions': void
  'body': void
  'breadcrumbs': void
  'ctas': void
  'details-heading': void
  'espot-above-accordions': void
  'espot-above-add-to-cart': void
  'espot-below-accordions': void
  'espot-lazy-above-footer': void
  'espot-lazy-below-gallery': void
  'gallery': void
  'heading': void
  'klarna-payments': void
  'notifications': void
  'paypal-payments': void
  'recommendations': void
  'reviews': void
  'reviews-summary': void
  'shipping-methods': void
  'shop-the-look': void
  'size-and-fit': void
  'skeletons': void
  'upsells': void
  'variant-selection': void
}>()

const { brandClasses, stickyDetailsColumn } = useAppConfig().pages?.pdp || {}
const header = useHeaderStore()
const { eSpots, product, productPending } = usePdp()
</script>
